<template>
    <div
        class="empty-container"
        :style="{
            paddingTop: `${paddingTop}rem`,
            paddingBottom: `${paddingBottom}rem`,
        }"
    >
        <div
            class="large-icon"
            v-if="iconSize == 'large'"
            :style="{ backgroundImage: `url(${iconSrc})` }"
        ></div>
        <div
            class="slim-icon"
            v-if="iconSize == 'slim'"
            :style="{ backgroundImage: `url(${iconSrc})` }"
        ></div>
        <div
            class="smallest-icon"
            v-if="iconSize == 'smallest'"
            :style="{ backgroundImage: `url(${iconSrc})` }"
        ></div>
        <div class="icon-text">
            <span>{{ iconText }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        //图标大小
        iconSize: {
            type: [String],
            default: "large",
        },
        //提示文本
        iconText: {
            type: [String],
            default: "这里的数据空空如也~",
        },
        //内边距 请写rem
        paddingTop: {
            type: [Number],
            default: 2,
        },
        //内边距 请写rem
        paddingBottom: {
            type: [Number],
            default: 0,
        },
        //图标地址
        iconSrc: {
            type: [String],
            required: true,
        },
    },
};
</script>
<style lang="less" scoped>
.empty-container {
    margin: 0 auto;
    width: 750px;
    .large-icon {
        margin: 0 auto;
        width: 260px;
        height: 260px;
        background-size: 260px;
        background-position: center;
        background-repeat: no-repeat;
    }
    .slim-icon {
        margin: 0 auto;
        width: 180px;
        height: 180px;
        background-size: 180px;
        background-position: center;
        background-repeat: no-repeat;
    }
    .smallest-icon {
        margin: 0 auto;
        width: 140px;
        height: 140px;
        background-size: 140px;
        background-position: center;
        background-repeat: no-repeat;
    }
    .icon-text {
        padding-top: 10px;
        font-size: 28px;
        line-height: 50px;
        color: #999;
        text-align: center;
    }
}
</style>
